module.exports = __webpack_public_path__ + "img/sort-icon.3477565b.svg";